<template>
    <div class="cancelAccount-agreement-component">
      <div class="title">
        <van-nav-bar
          title="用户注销"
          left-arrow
          @click-left="onClickLeft"
          fixed
        />
      </div>
      <h3 class="h3-title">《荷叶健康账号注销协议》</h3>
      <p>
        尊敬的用户，感谢您长久以来对荷叶健康的支持，在您决定注销您的荷叶健康账号之前，请您认真阅读、理解并同意本协议。本协议由您与荷叶健康平台的经营者海南宜贰叁互联网医院有限公司（以下简称“海南宜贰叁”）共同缔结，本协议具有合同效力。
      </p>
      <h4>第一：账号注销类型</h4>
      <p>
        1. 个人账号注销：
      </p>
      <p>
        当您申请注销的荷叶健康账号为个人账号时，应由您本人向荷叶健康提出注销申请。
      </p>
      <p>
         2. 企业账号注销：
      </p>
      <p>
        当您申请注销的荷叶健康账号为企业账号时，应由企业法定代表人或企业指定授权代表人向荷叶健康提出注销申请，不符合上述要求的，您将无法申请注销荷叶健康账号。
      </p>
      <h4>第二：注销条件</h4>
      <p>
        在您申请注销账号前，您应确保您有权决定处理该账号的注销事宜，不侵犯任何第三方的合法权益，如因此引发任何投诉争议，应由您自行承担全部责任。在您向我方提交账号注销申请后，我方将按照注销提示的相关说明，对您账号的相关情况进行逐一核查，通过核查确认您符合如下账号注销条件的，本协议即可生效：
      </p>
      <p>
        1. 账号没有未完成的交易；
      </p>
      <p>
        2. 账号没有未处理完的交易纠纷；
      </p>
      <p>
        3. 账号没有任何处罚记录；
      </p>
      <p>
        4. 账号账户内无余额；
      </p>
      <p>
        5. 店铺商品全部已下架；
      </p>
      <p>
        6. 店铺需关闭点亮荷叶健康服务；
      </p>
      <p>
        7. 店铺保证金已退还。
      </p>
      <h4>第三：账号注销的程序</h4>
      <p>
        我们在此善意提醒，账号一旦注销后，我们将无法协助您找回，请您备份好账号下所有信息后谨慎操作。您注销账户后，除满足《网络安全法》对于数据留存的强制性要求外，我们将在相关行为的诉讼时效届满后，对您的个人信息予以删除或匿名化处理。
      </p>
      <p>
        1.按照注销页面提示，发起账号注销。
      </p>
      <p>
        2.您发起账户注销之时起，系统将启动自动核查机制，该机制无法强行中止，如通过自动核查，且法律法规无相反规定的，账号将自动删除。
      </p>
      <p>
        3.系统自动核查中，如发现相关账号下存在未完成的订单、服务，或其他不符合注销条件的，系统将提示错误信息，账号注销程序将自动中止，且不会自动恢复。如果您希望继续注销的，请您按照提示完成相关操作，符合注销条件后请您重新发起账号注销。
      </p>
      <p>
        4.账号注销期间，如果我方发现您的荷叶健康账号被他人投诉、被国家机关调查或者正处于诉讼、仲裁程序中，我方有权自行终止您账号注销进程而无需另行得到您的同意。
      </p>
      <p>
        5.账号注销过程需要一定时间，请您耐心等待。
      </p>
      <h4>第四：账号注销的后果</h4>
      <p>
        账号注销意味着账号协议及该账号下所有服务条款、协议、合同等一并解除，将对您造成如下后果：
      </p>
      <p>
        1.您将无法再次登录荷叶健康网站、APP等；
      </p>
      <p>
        2.您将无法进行依赖于账号权限进行的其他操作；
      </p>
      <p>
        3.您将无法找回该账号下的个人信息、交易记录、业务数据、历史信息等。
      </p>
      <h4>提示：</h4>
      <p>
        账号注销并不代表您在该账号注销前的所有账号行为和相关责任得到豁免或减轻。您在此再次保证已经完全阅读并理解了上述账号注销协议，并自愿正式进入账号注销的后续流程，接受上述条款的约束。
      </p>
    </div>
  </template>
  <script>
  export default {
    data() {
      return {
        isShow: false,
      };
    },
    created() {
       
    },
    mounted(){
          
    },
    activated(){},
    watch: {
      '$route.query.isShow':() =>{
         
      }
    },
  
    methods: {
      onClickLeft() {
        this.$router.back(-1);
      }
    },
  
  };
  </script>
  
  <style scoped lang="scss">
  .cancelAccount-agreement-component {
    margin-top: 20px;
    font-size: 14px;
    padding: 0 10px 10px;
    h3 {
      text-align: center;
    }
    .title {
      margin: 10px 0;
    }
    .h3-title {
      margin-top: 1.6rem;
    }
    p {
      text-indent: 2em;
      margin: 2px 0;
    }
  }
  /deep/ .van-nav-bar__text {
    color: #333;
  }
  /deep/ .van-nav-bar .van-icon {
    color: #333;
  }
  </style>